/** Live ESS portal status for create/edit employee footer. */

export function formatEssLoginAt(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return String(iso);
  }
}

/**
 * @returns {{ key: string, label: string, tone: 'muted'|'info'|'warning'|'success' }}
 */
export function resolveEssPortalStatus({
  essEnabled,
  inviteSent,
  welcomeEmailSent,
  lastLoginAt,
} = {}) {
  if (!essEnabled) {
    return {
      key: "disabled",
      label: "ESS disabled",
      tone: "muted",
    };
  }
  if (lastLoginAt) {
    return {
      key: "logged_in",
      label: `Last login: ${formatEssLoginAt(lastLoginAt)}`,
      tone: "success",
    };
  }
  if (welcomeEmailSent || inviteSent) {
    return {
      key: "link_sent",
      label: "Link sent — employee yet to login",
      tone: "warning",
    };
  }
  return {
    key: "enabled_no_invite",
    label: "ESS enabled — invite not sent",
    tone: "info",
  };
}

export function essStatusClass(tone, darkMode = false) {
  if (tone === "success") return "text-[hsl(var(--ds-success))]";
  if (tone === "warning") return "text-[hsl(var(--ds-warning-fg))]";
  if (tone === "info") return "text-[hsl(var(--ds-info))]";
  return "text-[hsl(var(--ds-muted-fg))]";
}
